import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, onMounted, ref, watch, watchEffect } from "@vue/composition-api";
import ReportTabLayout from "../report-tab-layout.vue";
import LenderTransactionsContainerLoader from "./lender-transactions-container-loader.vue";
import ReportToolbar from "../report-toolbar.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import AgentsSelect from "@Broker/@Modules/agents/components/agents-select.vue";
import SelectLevel from "../select-level.vue";
import SelectFormat from "../select-format.vue";
import SelectLender from "../select-lender.vue";
import { useI18n } from "vue-i18n-composable";
import SelectApplicationStatus from "../select-application-status.vue";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import { REPORT_APPLICATION_STATUS_E, REPORT_DATE_TYPE_E, REPORT_GROUP_BY_E, REPORT_LEVEL_E, REPORT_SORT_BY_E } from "@Broker/@Types/reports/types";
import * as ReportsGetters from "@Broker/@Modules/clients/reports/store/reports-getters";
import { useReportsStoreGetters } from "../../store/reports-helpers";
import { capitalize, cloneDeep } from "lodash";
import { required, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { useAIRDateRange } from "@Broker/@Composables/reports/useAIRDateRange";
import { useReportDefaultSettings } from "@Broker/@Composables/reports/useReportDefaultSettings";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "LenderTransactionsContainer",
  components: {
    ReportTabLayout,
    LenderTransactionsContainerLoader,
    ReportToolbar,
    MaterialInput,
    DateSection,
    Field,
    SelectLevel,
    SelectFormat,
    SelectApplicationStatus,
    SelectLender,
    vSelectField,
    AgentsSelect
  },
  mixins: [validationMixin],
  validations() {
    return {
      localLenderTransactionData: {
        agent: {
          required: requiredIf(() => this.showAgentsSelect)
        },
        format: {
          required
        },
        level: {
          required
        },
        lender: {
          required
        },
        applicationStatus: {
          required
        },
        dateType: {
          required
        },
        groupBy: {
          required
        },
        dateFrom: {
          required
        },
        dateTo: {
          required
        }
      }
    };
  },
  props: {
    runningReport: {
      type: Object,
      default: () => ({
        loading: false,
        loadingSucceeded: true
      })
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const {
      v$
    } = useVuelidate();
    const loading = ref(false);
    const settingDefault = ref({
      loading: false,
      loadingSucceeded: true
    });
    const unsyncedAppsModal = ref();
    const {
      CURRENT_ACCOUNT_IS_BROKER,
      CURRENT_USER_USERNAME
    } = useAccountStoreGetters([AccountGetters.CURRENT_ACCOUNT_IS_BROKER, AccountGetters.CURRENT_USER_USERNAME]);
    const action = ref();
    const {
      GET_LENDER_TRANSACTION_STRUCTURE
    } = useReportsStoreGetters([ReportsGetters.GET_LENDER_TRANSACTION_STRUCTURE]);
    const lenderTransactionStructure = cloneDeep(GET_LENDER_TRANSACTION_STRUCTURE.value);
    const localLenderTransactionData = ref(lenderTransactionStructure);
    const agentsOptions = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const handleSelectAgentChange = (value, type) => localLenderTransactionData.value.agent = handleSelectMultipleChange(value, type, localLenderTransactionData.value.agent, true);
    const handleChangeDates = dates => {
      const {
        end,
        start
      } = dates;
      localLenderTransactionData.value.dateFrom = start;
      localLenderTransactionData.value.dateTo = end;
    };
    const {
      airDateRange
    } = useAIRDateRange();
    const handleChangeAIR = () => {
      if (!localLenderTransactionData.value || !localLenderTransactionData.value.filterForAIR) return;
      localLenderTransactionData.value = _objectSpread(_objectSpread({}, localLenderTransactionData.value), {}, {
        level: CURRENT_ACCOUNT_IS_BROKER.value ? REPORT_LEVEL_E.BROKERAGE : REPORT_LEVEL_E.AGENT,
        dateType: REPORT_DATE_TYPE_E.SUBMISSION_DATE,
        dateFrom: airDateRange.value.dateFrom,
        dateTo: airDateRange.value.dateTo,
        applicationStatus: [REPORT_APPLICATION_STATUS_E.PAID, REPORT_APPLICATION_STATUS_E.CLOSED]
      });
    };
    const {
      loadReportDefaultValues,
      updateReportDefaults
    } = useReportDefaultSettings({
      reportType: "lenderTransactions",
      reportDataRef: localLenderTransactionData
    });
    const setDefault = () => {
      loadReportDefaultValues();
    };
    const dateTypeOptions = computed(() => {
      return [{
        text: t("application-reports.firm-statistics.submissionDate"),
        id: REPORT_DATE_TYPE_E.SUBMISSION_DATE
      }, {
        text: t("application-reports.firm-statistics.approvalDate"),
        id: REPORT_DATE_TYPE_E.APPROVAL_DATE
      }];
    });
    const sortBySelectOptions = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const groupBySelectOptions = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const allAgentsOption = {
      id: "all",
      username: "all",
      givenName: capitalize(tc("global.words.all", 1)),
      familyName: ""
    };
    const brokerageOption = computed(() => localLenderTransactionData.value.level === REPORT_LEVEL_E.BROKERAGE ? [{
      id: REPORT_LEVEL_E.BROKERAGE,
      text: t("global.doorr.brokerage")
    }] : []);
    const agentOption = computed(() => CURRENT_ACCOUNT_IS_BROKER.value ? [{
      id: REPORT_LEVEL_E.AGENT,
      text: capitalize(tc("global.doorr.agent", 1))
    }] : []);
    const sortByDateOption = computed(() => localLenderTransactionData.value.dateType === REPORT_DATE_TYPE_E.SUBMISSION_DATE ? [{
      id: REPORT_DATE_TYPE_E.SUBMISSION_DATE,
      text: t("application-reports.firm-statistics.submissionDate")
    }] : [{
      text: t("application-reports.firm-statistics.approvalDate"),
      id: REPORT_DATE_TYPE_E.APPROVAL_DATE
    }]);
    const groupByOptions = computed(() => [{
      id: REPORT_GROUP_BY_E.APPLICATION_STATUS,
      text: t("application-reports.applicationStatus")
    }, {
      id: REPORT_GROUP_BY_E.LENDER,
      text: t("global.doorr.lender")
    }, {
      id: REPORT_GROUP_BY_E.MORTGAGE_TYPE,
      text: t("application-reports.mortgageType")
    }, {
      id: REPORT_GROUP_BY_E.APPLICATION_TYPE,
      text: t("application-reports.applicationType")
    }, {
      id: REPORT_GROUP_BY_E.SUBMISSION_STATUS,
      text: t("application-reports.lender-transactions.submissionStatus")
    }, {
      id: REPORT_GROUP_BY_E.AGENT,
      text: capitalize(tc("global.doorr.agent", 1))
    }, ...brokerageOption.value]);
    const sortByOptions = computed(() => [{
      id: REPORT_SORT_BY_E.LENDER,
      text: t("global.doorr.lender")
    }, {
      id: REPORT_SORT_BY_E.MORTGAGE_TYPE,
      text: t("application-reports.mortgageType")
    }, {
      id: REPORT_SORT_BY_E.APPLICATION_TYPE,
      text: t("application-reports.applicationType")
    }, {
      id: REPORT_SORT_BY_E.APPLICANT_SURNAME,
      text: t("application-reports.applications-summary.applicantSurname")
    }, {
      id: REPORT_SORT_BY_E.APPLICATION_ID,
      text: t("application.applicationID")
    }, ...sortByDateOption.value, ...agentOption.value, {
      id: REPORT_SORT_BY_E.SUBMISSION_STATUS,
      text: t("application-reports.lender-transactions.submissionStatus")
    }, {
      id: REPORT_SORT_BY_E.APR,
      text: t("application-reports.apr")
    }]);
    onMounted(() => {
      setDefaultAgentIfNeeded();
    });
    const setDefaultAgentIfNeeded = () => {
      if (!CURRENT_ACCOUNT_IS_BROKER.value) localLenderTransactionData.value.agent = [CURRENT_USER_USERNAME.value];
    };
    const handleClearSelection = () => {
      localLenderTransactionData.value = cloneDeep(lenderTransactionStructure);
      setDefaultAgentIfNeeded();
      action.value = "clear";
    };
    const handleResetToDefault = () => {
      setDefault();
      setDefaultAgentIfNeeded();
      action.value = "reset";
    };
    const handleSetDefault = async () => {
      settingDefault.value.loading = true;
      const {
        agent: agents,
        format,
        level,
        lender,
        groupBy,
        sortBy: [sortByPrimary, sortBySecondary],
        dateFrom,
        dateTo,
        dateType,
        applicationStatus,
        filterForAIR: annualInformationReturn
      } = localLenderTransactionData.value;
      await updateReportDefaults({
        agents,
        level,
        lender,
        groupBy,
        sortByPrimary,
        sortBySecondary,
        dateFrom,
        dateTo,
        applicationStatus,
        dateType,
        annualInformationReturn,
        format
      });
      settingDefault.value.loading = false;
    };
    const handleRunReport = async () => {
      emit("run-report", {
        reportType: "lender-transaction",
        data: localLenderTransactionData.value
      });
    };
    const handleChangeGroupBy = ({
      id
    }) => {
      localLenderTransactionData.value.groupBy = id;
    };
    const primaryOptions = computed(() => {
      var _context;
      return _filterInstanceProperty(_context = sortByOptions.value).call(_context, val => val.id !== localLenderTransactionData.value.sortBy[1]);
    });
    const secondaryOptions = computed(() => {
      var _context2;
      return _filterInstanceProperty(_context2 = sortByOptions.value).call(_context2, val => val.id !== localLenderTransactionData.value.sortBy[0]);
    });
    const handleChangeSortBy = ({
      id
    }, sortByIndex) => {
      var _context3;
      _spliceInstanceProperty(_context3 = localLenderTransactionData.value.sortBy).call(_context3, sortByIndex, 1, id);
    };
    const showAgentsSelect = computed(() => {
      return CURRENT_ACCOUNT_IS_BROKER.value && localLenderTransactionData.value.level === REPORT_LEVEL_E.AGENT;
    });
    watch(() => localLenderTransactionData.value.level, (selectedLevel, oldSelectedLevel) => {
      if (selectedLevel === oldSelectedLevel) return;
      if (selectedLevel === REPORT_LEVEL_E.BROKERAGE) {
        localLenderTransactionData.value.agent = "all";
      }
    });
    watchEffect(() => {
      if (!localLenderTransactionData.value.groupBy) {
        localLenderTransactionData.value.groupBy = REPORT_GROUP_BY_E.APPLICATION_STATUS;
      }
      if (!localLenderTransactionData.value.sortBy[0]) {
        localLenderTransactionData.value.sortBy[0] = REPORT_SORT_BY_E.LENDER;
      }
      if (!localLenderTransactionData.value.sortBy[1]) {
        localLenderTransactionData.value.sortBy[1] = REPORT_SORT_BY_E.APPLICANT_SURNAME;
      }
    });
    return {
      action,
      loading,
      showAgentsSelect,
      settingDefault,
      v$,
      agentsOptions,
      lenderTransactionStructure,
      localLenderTransactionData,
      groupByOptions,
      sortByOptions,
      dateTypeOptions,
      sortBySelectOptions,
      groupBySelectOptions,
      allAgentsOption,
      unsyncedAppsModal,
      handleSelectAgentChange,
      handleChangeDates,
      handleChangeAIR,
      handleRunReport,
      handleResetToDefault,
      handleClearSelection,
      handleSetDefault,
      handleChangeGroupBy,
      handleChangeSortBy,
      setDefaultAgentIfNeeded,
      primaryOptions,
      secondaryOptions
    };
  }
});